<template>
    <v-dialog v-model="getModalExcluirLancamentoCaixa" max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Excluir
            </v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja excluir este grupo?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalExcluirLancamentoCaixa(false)" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="excluirLancamentoCaixa(getLancamentoCaixa)" outlined>Sim</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalExcluirLancamentoCaixa',
                'getLancamentoCaixa'
            ])
        },
        methods: {
            ...mapActions([
                'setModalExcluirLancamentoCaixa',
                'excluirLancamentoCaixa'
            ])
        }
    }
</script>